import ThankYouPage from './ThankYouPage'

const ConstructionNewQuoteThankYou = () => (
    <ThankYouPage returnPath="/construction" contentCategory="Construction" />
)

export default ConstructionNewQuoteThankYou
